<template>
  <a-row :gutter="24" type="flex">
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日我的收款/付款客人数量："
          :value="`${numeral(200).format('0,0')}元/1人`"
        />
        <!--        <a-progress v-if="(200/715) * 100 > 100" :percent="(200/715) * 100 - 100" size="small" status="active" :format="format" />-->
        <!--        <a-progress-->
        <!--          v-if="(200/715) * 100 <= 100"-->
        <!--          :percent="(200/715) * 100"-->
        <!--          size="small"-->
        <!--          :stroke-color="{-->
        <!--            '0%': '#ff0000',-->
        <!--            '100%': '#ff0000',-->
        <!--          }"-->
        <!--        />-->
        <field label="昨日我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field label="本月我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <field label="上月我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <!--        <field-->
        <!--          label="同期收款："-->
        <!--          :value="`${numeral(500).format('0,0')}元`"-->
        <!--        />-->
        <!--        <trend flag="up" style="margin-right: 16px">-->
        <!--          目标同比增长-->
        <!--          <span class="trendText">12%</span>-->
        <!--        </trend>-->
        <!--        <trend flag="down">-->
        <!--          目标同比下降-->
        <!--          <span class="trendText">11%</span>-->
        <!--        </trend>-->
        <!--        <field-->
        <!--          label="本年累计收款"-->
        <!--          :value="`${numeral(20200).format('0,0')}元`"-->
        <!--        />-->
        <!--        -->
        <!--        <field-big-->
        <!--          label="昨日门店收款"-->
        <!--          :value="`${numeral(100).format('0,0')}元`"-->
        <!--        />-->
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日我的收款/付款客人数量："
          :value="`${numeral(200).format('0,0')}元/1人`"
        />
        <!--        <a-progress v-if="(200/715) * 100 > 100" :percent="(200/715) * 100 - 100" size="small" status="active" :format="format" />-->
        <!--        <a-progress-->
        <!--          v-if="(200/715) * 100 <= 100"-->
        <!--          :percent="(200/715) * 100"-->
        <!--          size="small"-->
        <!--          :stroke-color="{-->
        <!--            '0%': '#ff0000',-->
        <!--            '100%': '#ff0000',-->
        <!--          }"-->
        <!--        />-->
        <field label="昨日我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field label="本月我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <field label="上月我的收款/付款客人数量：" :value="`${numeral(200).format('0,0')}元/1人`" />
        <!--        <field-->
        <!--          label="同期收款："-->
        <!--          :value="`${numeral(500).format('0,0')}元`"-->
        <!--        />-->
        <!--        <trend flag="up" style="margin-right: 16px">-->
        <!--          目标同比增长-->
        <!--          <span class="trendText">12%</span>-->
        <!--        </trend>-->
        <!--        <trend flag="down">-->
        <!--          目标同比下降-->
        <!--          <span class="trendText">11%</span>-->
        <!--        </trend>-->
        <!--        <field-->
        <!--          label="本年累计收款"-->
        <!--          :value="`${numeral(20200).format('0,0')}元`"-->
        <!--        />-->
        <!--        -->
        <!--        <field-big-->
        <!--          label="昨日门店收款"-->
        <!--          :value="`${numeral(100).format('0,0')}元`"-->
        <!--        />-->
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big label="本月收款目标" :value="`${numeral(200).format('0,0')}元`" />
        <!--        <a-progress v-if="(200/715) * 100 > 100" :percent="(200/715) * 100 - 100" size="small" status="active" :format="format" />-->
        <!--        <a-progress-->
        <!--          v-if="(200/715) * 100 <= 100"-->
        <!--          :percent="(200/715) * 100"-->
        <!--          size="small"-->
        <!--          :stroke-color="{-->
        <!--            '0%': '#ff0000',-->
        <!--            '100%': '#ff0000',-->
        <!--          }"-->
        <!--        />-->
        <field label="上年同期收款" :value="`${numeral(200).format('0,0')}元`" />
        <trend flag="up" style="margin-right: 16px">
          目标同比增长
          <span class="trendText">12%</span>
        </trend>
        <trend flag="down">
          目标同比下降
          <span class="trendText">11%</span>
        </trend>
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <!--        <field-->
        <!--          label="同期收款："-->
        <!--          :value="`${numeral(500).format('0,0')}元`"-->
        <!--        />-->
        <!--        <trend flag="up" style="margin-right: 16px">-->
        <!--          目标同比增长-->
        <!--          <span class="trendText">12%</span>-->
        <!--        </trend>-->
        <!--        <trend flag="down">-->
        <!--          目标同比下降-->
        <!--          <span class="trendText">11%</span>-->
        <!--        </trend>-->
        <!--        <field-->
        <!--          label="本年累计收款"-->
        <!--          :value="`${numeral(20200).format('0,0')}元`"-->
        <!--        />-->
        <!--        -->
        <field-big label="本年累计收款" :value="`${numeral(100).format('0,0')}元`" />
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big label="本月收款目标" :value="`${numeral(200).format('0,0')}元`" />
        <!--        <a-progress v-if="(200/715) * 100 > 100" :percent="(200/715) * 100 - 100" size="small" status="active" :format="format" />-->
        <!--        <a-progress-->
        <!--          v-if="(200/715) * 100 <= 100"-->
        <!--          :percent="(200/715) * 100"-->
        <!--          size="small"-->
        <!--          :stroke-color="{-->
        <!--            '0%': '#ff0000',-->
        <!--            '100%': '#ff0000',-->
        <!--          }"-->
        <!--        />-->
        <field label="上年同期收款" :value="`${numeral(200).format('0,0')}元`" />
        <trend flag="up" style="margin-right: 16px">
          目标同比增长
          <span class="trendText">12%</span>
        </trend>
        <trend flag="down">
          目标同比下降
          <span class="trendText">11%</span>
        </trend>
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <!--        <field-->
        <!--          label="同期收款："-->
        <!--          :value="`${numeral(500).format('0,0')}元`"-->
        <!--        />-->
        <!--        <trend flag="up" style="margin-right: 16px">-->
        <!--          目标同比增长-->
        <!--          <span class="trendText">12%</span>-->
        <!--        </trend>-->
        <!--        <trend flag="down">-->
        <!--          目标同比下降-->
        <!--          <span class="trendText">11%</span>-->
        <!--        </trend>-->
        <!--        <field-->
        <!--          label="本年累计收款"-->
        <!--          :value="`${numeral(20200).format('0,0')}元`"-->
        <!--        />-->
        <!--        -->
        <field-big label="本年累计收款" :value="`${numeral(100).format('0,0')}元`" />
      </a-card>
    </a-col>
  </a-row>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { InfoCircleOutlined } from '@ant-design/icons-vue';
import { ChartCard, Field, FieldBig, MiniProgress, MiniBar, MiniArea } from './charts';
import Yuan from './yuan.vue';
import Trend from './trend/index.vue';
import numeral from 'numeral';
import { VisitDataItem } from '@/api/dashboard/analysis';

const gridLayout = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
};

export default defineComponent({
  name: 'IntroduceRow',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    const format = (percent: any) => {
      return '+' + percent + '%';
    };
    return {
      gridLayout,
      numeral,
      format,
    };
  },
  components: {
    ChartCard,
    Field,
    Trend,
    MiniProgress,
    MiniBar,
    MiniArea,
    FieldBig,
    Yuan,

    // icons
    InfoCircleOutlined,
  },
});
</script>
